export default {
  SET_PARENT_EVENT_INFO: (state, data) => state.parentEventInfo = data,
  SET_CHILD_EVENT_INFO: (state, data) => state.childEventInfo = data,
  RESET_PARENT_EVENT_INFO: (state) => state.parentEventInfo = null,
  SET_DUPLICATE_USER: (state, data) => state.isDuplicateUser = data,
  SET_ERROR_ADDRESS: (state, data) => state.isErrorAddress = data,
  SET_PHONE_INFO: (state, data) => state.phoneInfo = data,
  SET_ERROR_USER: (state, data) => state.isErrorUser = data,
  SET_VALID_USER: (state, data) => state.isValidUser = data,
  SET_BLOCK_USER: (state, data) => state.isBlockedSms = data,
  REMOVE_BLOCK_USER: (state) => state.isBlockedSms = false,
  SET_VALID_KEYWORD: (state, data) => state.isValidKeyword = data,
};
